"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveUploadsCount = void 0;
var models_1 = require("@app/_state/models");
var getActiveUploadsCount = function (store) {
    // return store.pendingUploads.pendingUploads.valueSeq().toArray().filter(
    //   (u) => (u.state === PackageTransferState.IN_PROGRESS || (u.state !== PackageTransferState.FAILED && u.state !== PackageTransferState.STOPPED && u.transferredBytes < u.size))).length;
    return store.pendingUploads.pendingUploads.valueSeq().toArray().filter(function (u) { return u.state === models_1.PackageTransferState.IN_PROGRESS; }).length;
};
exports.getActiveUploadsCount = getActiveUploadsCount;
